module.exports = __webpack_public_path__ + "static/media/dedicated_editor.33975550.svg";